import { render, staticRenderFns } from "./markedText.vue?vue&type=template&id=1bf93c24&"
import script from "./markedText.vue?vue&type=script&lang=ts&"
export * from "./markedText.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports